import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable()
export class ByocEpisodeFetchService {
    /**
     * Edititing Questions
     */
    editing!: boolean;

    /**
     * Edititing Index
     */
    editingIndex!: number | null;

    /**
     * Update Perfect Scrollbar position event
     */
    private updatePsSubject = new Subject<boolean>();

    /**
     * Update Perfect Scrollbar position event
     */
    private updatePsScrollToSubject = new Subject<number>();

    /**
     * Update Perfect Scrollbar - scroll to bottom position event
     */
    private updatePsScrollBottomSubject = new Subject<boolean>();

    /**
     * Close event
     */
    private closeSubject = new Subject<boolean>();

    /**
     * Refresh PS Emit Evetn
     */
    updatePs(): void {
        this.updatePsSubject.next(true);
    }

    /**
     * Refresh PS Observable
     */
    get updatePsEvent(): Observable<boolean> {
        return this.updatePsSubject.asObservable();
    }

    /**
     * Refresh PS - scroll to Position
     */
    updatePsScrollTo(position: number): void {
        this.updatePsScrollToSubject.next(position);
    }

    /**
     * Refresh PS Observable
     */
    get updatePsScrollToEvent(): Observable<number> {
        return this.updatePsScrollToSubject.asObservable();
    }

    /**
     * Refresh PS - scroll to bottom Emit Evetn
     */
    updatePsScrollBottom(): void {
        this.updatePsScrollBottomSubject.next(true);
    }

    /**
     * Refresh PS - scroll to bottom Observable
     */
    get updatePsScrollBottomEvent(): Observable<boolean> {
        return this.updatePsScrollBottomSubject.asObservable();
    }

    /**
     * Close Emit Event
     */
    close(): void {
        this.editing = false;
        this.editingIndex = null;
        this.closeSubject.next(true);
    }

    /**
     * Close Observable
     */
    get closeEvent(): Observable<boolean> {
        return this.closeSubject.asObservable();
    }
}
